export default __webpack_public_path__ + "static/media/003-Jigsaw.583976af.svg";